module.exports = __webpack_public_path__ + "aws_logoblack.png";